<template>
  <div>
    <div class="breadcrumb-wrap">
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
        class="breadcrumb-custom"
      >
        <el-breadcrumb-item>微信用户管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-dialog
      :visible.sync="editPasswordVisible"
      title="修改密码"
      :width="dialogWidth"
    >
      <div v-if="editRow != null">
        <div>手机号：{{ editRow.mobile }}</div>
        <div style="margin-top: 20px">
          <el-input
            class="margin-space"
            placeholder="输入新密码"
            v-model="newPassword"
            size="small"
            type="password"
          >
            <template slot="prepend"
              >新密码</template
            >
          </el-input>
        </div>
        <div style="text-align: center; margin-top: 20px">
          <el-button size="small" type="primary" @click="sureEditPassword"
            >确认</el-button
          >
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dayVisible" title="续费" :width="dialogWidth">
      <div v-if="dayEditRow != null">
        <div>手机号：{{ dayEditRow.mobile }}</div>
        <div style="margin-top: 20px">
          截止日期：{{ dayEditRow.expiryDate }}
        </div>
        <div style="margin-top: 20px">
          <el-input
            class="margin-space"
            placeholder="输入天数"
            v-model="newDay"
            size="small"
          >
            <template slot="prepend"
              >天数</template
            >
          </el-input>
        </div>
        <div style="text-align: center; margin-top: 20px">
          <el-button size="small" type="primary" @click="sureEditDay"
            >确认</el-button
          >
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="addUserVisible"
      title="新增用户"
      :width="dialogWidth"
    >
      <el-input
        class="margin-space"
        placeholder="请输入用户名"
        v-model="addUserObj.mobile"
      >
        <template slot="prepend"
          >手机号码</template
        >
      </el-input>
      <el-input
        type="password"
        class="margin-space"
        placeholder="请输入密码"
        v-model="addUserObj.password"
      >
        <template slot="prepend"
          >密码</template
        >
      </el-input>

      <el-input
        class="margin-space"
        placeholder="请输入天数"
        type="number"
        v-model="addUserObj.day"
      >
        <template slot="prepend"
          >开通天数</template
        >
      </el-input>
      <el-input
        class="margin-space"
        placeholder="请输入备注"
        v-model="addUserObj.remarks"
      >
        <template slot="prepend"
          >备注</template
        >
      </el-input>
      <div style="text-align: right" class="margin-space">
        <el-button
          :loading="addUserLoading"
          type="primary"
          @click="addConfirmClick"
        >
          确认
        </el-button>
      </div>
    </el-dialog>
    <div style="margin-bottom: 10px; margin-top: 20px">
      <el-row>
        <el-col :span="8">
          <el-input
            size="small"
            placeholder="输入手机号码"
            v-model="searchValue"
          />
        </el-col>
        <el-col :span="14" style="margin-left: 10px">
          <el-button
            @click="searchClick"
            type="primary"
            size="small"
            icon="el-icon-search"
            >搜索</el-button
          >
          <el-button
            @click="(e) => searchClick(true)"
            size="small"
            icon="el-icon-search"
          >
            重置</el-button
          >
        </el-col>
      </el-row>
    </div>
    <LoadingNoDialog :loading="loading">
      <el-table class="clear-fix" border :data="tableData" style="width: 100%">
        <el-table-column prop="nickName" label="昵称"> </el-table-column>

        <el-table-column prop="mobile" label="手机号码"> </el-table-column>
        <el-table-column prop="avatar" label="用户头像">
          <template slot-scope="scope">
            <img :src="scope.row.avatar" style="max-height:80px" />
          </template>
        </el-table-column>

        <el-table-column prop="count" label="访问次数"> </el-table-column>

        <el-table-column prop="createdAt" label="创建时间"> </el-table-column>
      </el-table>

      <div style="margin-top: 10px; text-align: right">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 50, 100, 500, 1000]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </LoadingNoDialog>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import LoadingNoDialog from "../../components/LoadingNoDialog.vue";
import ElButton from "../../../node_modules/element-ui/packages/button/src/button.vue";
import ElDialog from "../../../node_modules/element-ui/packages/dialog/src/component.vue";
import Img from "../../components/Img.vue";

export default {
  name: "Role",
  data() {
    let dWidth = "95%";
    if (window.isPc) {
      dWidth = "40%";
    }
    return {
      size: 10,
      page: 1,
      tableData: [],
      total: 0,
      loading: false,
      addUserVisible: false,
      addUserLoading: false,
      addUserObj: {
        mobile: "",
        password: "",
        day: "",
        remarks: "",
      },
      dialogWidth: dWidth,
      searchValue: "",
      editPasswordVisible: false,
      editRow: null,
      newPassword: "",
      dayVisible: false,
      dayEditRow: null,
      newDay: "",
    };
  },
  components: {
    ElDialog,
    ElButton,
    LoadingNoDialog,
    Img,
  },
  mounted() {
    this.getList();
  },
  methods: {
    async getList() {
      this.loading = true;
      let params = { page: this.page, size: this.size };
      if (this.searchValue) {
        params.searchValue = this.searchValue;
      }
      let r = await axios.get("/admin/wx/user/list", {
        params,
      });
      this.tableData = r.rows.map((item) =>
        Object.assign(
          item,
          {
            expiryDate: moment(item.expiryDate).format(
              "YYYY年MM月DD日 HH:mm:ss"
            ),
          },
          {
            createdAt: moment(item.createdAt).format("YYYY年MM月DD日 HH:mm:ss"),
          }
        )
      );
      this.total = r.count;
      this.loading = false;
    },
    handleSizeChange(val) {
      this.size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    formatterUserType(rows, colum) {
      console.info(rows);
      if (rows.type == -2) {
        return "超级管理员";
      }
      if (rows.type == -1) {
        return "后台管理员";
      }
      if (rows.type == 0) {
        return "普通用户";
      }
      if (rows.type == 1) {
        return "企业用户";
      }
      if (rows.type == 2) {
        return "设计师用户";
      }
    },
    addUserClick() {
      this.addUserObj = {
        mobile: "",
        password: "",
        day: "",
      };
      this.addUserVisible = true;
    },
    async addConfirmClick() {
      let mobileReg = /^[1][3,4,5,7,8][0-9]{9}$/;
      let isMobile = mobileReg.test(this.addUserObj.mobile);
      if (!isMobile) {
        this.$message.warning("请输入正确的手机号码");
        return;
      }
      if (this.addUserObj.password == "") {
        this.$message.warning("请输入密码");
        return;
      }

      let dayReg = /(^[1-9]\d*$)/;
      let isDay = dayReg.test(this.addUserObj.day);
      if (!isDay) {
        this.$message.warning("请输入正确的天数");
        return;
      }
      this.addUserLoading = true;
      let r = await axios.post("/admin/wx/user/create", this.addUserObj);
      if (r.code == 1001) {
        this.$message.warning("用户名或密码后手机号码为空！");
        this.addUserLoading = false;
        return;
      }
      if (r.code == 122) {
        this.$message.warning("手机号码或用户名已经存在");
        this.addUserLoading = false;

        return;
      }
      this.addUserLoading = false;
      this.addUserVisible = false;
      this.getList();
    },
    searchClick(isCancel) {
      if (isCancel == true) {
        this.searchValue = "";
      }
      this.page = 1;
      this.getList();
    },
    editPassword(row) {
      this.editRow = null;
      this.newPassword = "";
      this.editPasswordVisible = true;
      this.editRow = row;
    },
    async sureEditPassword() {
      try {
        let r = await await axios.post("/admin/wx/user/edit/pasword", {
          newPassword: this.newPassword,
          id: this.editRow.id,
        });
        if (r.code == 0) {
          this.$message.success("修改成功");
          this.getList();
        } else {
          this.$message.warning("修改失败");
        }
        this.editPasswordVisible = false;
      } catch (e) {
        console.error(e);
      }
    },
    addDay(row) {
      this.newDay = "";
      this.dayVisible = true;
      this.dayEditRow = row;
    },
    async sureEditDay() {
      try {
        this.dayVisible = false;
        let r = await axios.post("/admin/add/day", {
          id: this.dayEditRow.id,
          day: this.newDay,
        });
        if (r.code == 0) {
          this.$message.success("续费成功");
          this.getList();
        } else {
          this.$message.warning("续费失败");
        }
      } catch (e) {}
    },
    resetUser(row) {
      this.$confirm("是否确定解除微信绑定? 手机号：" + row.mobile, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let r = await axios.post("/admin/reset/wx/user", {
          id: row.id,
        });
        if (r.code == 0) {
          this.$message.success("解除成功");
          this.getList();
        } else {
          this.$message.success("解除失败");
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/main/admin/WxUser.vue